<template lang="pug">
  .layout
    .layout-toolbar(v-if="$slots.toolbar"): slot(name="toolbar")
    .layout-main
      .layout-sidebar(v-if="$slots.sidebar" :class="sidebarClass"): slot(name="sidebar")
      .layout-content.has-scroll(@scroll="onScroll" :class="contentClass")
        //- .navbar.is-grey(v-if="$slots.navbar"): slot(name="navbar")
        //- .container(v-if="$slots.content")
        //-   slot(name="content")
        slot(name="content")
    .layout-statusbar(v-if="$slots.statusbar"): slot(name="statusbar")
</template>

<script>
export default {
  name: 'layout',

  props: {
    // small
    sidebarSize: { type: String },
    sidebarStyle: { type: String },
    contentStyle: { type: String },
  },

  computed: {
    sidebarClass() {
      return [
        this.sidebarSize ? `is-${this.sidebarSize}` : null,
        this.sidebarStyle ? `has-background-${this.sidebarStyle}` : null,
      ];
    },
    contentClass() {
      return [this.contentStyle ? `has-background-${this.contentStyle}` : null];
    },
  },

  methods: {
    onScroll(e) {
      if (e.target) {
        this.$emit(
          'scrollContent',
          (e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight)) * 100
        );
      }
    },
  },
};
</script>
